// extracted by mini-css-extract-plugin
export default {"container":"LifeTimeSupport_container__AfrCE","text_box":"LifeTimeSupport_text_box__wMnKV"};